"use client";

import React, { type ReactNode } from "react";
import { UnstyledButton } from "@mantine/core";
import { useNativeSignIn } from "@/hooks/useNativeSignIn";

type AuthSignInButtonProps = {
  children?: ReactNode;
};

export default function AuthSignInButton({ children }: AuthSignInButtonProps) {
  const { openSignIn } = useNativeSignIn();

  if (!React.isValidElement(children)) {
    return (
      <UnstyledButton type="button" data-sign-in-button onClick={() => void openSignIn()}>
        SIGN IN
      </UnstyledButton>
    );
  }

  const child = children as React.ReactElement<{
    onClick?: (event: React.MouseEvent) => void;
    "data-sign-in-button"?: boolean;
  }>;

  return React.cloneElement(child, {
    "data-sign-in-button": true,
    onClick: (event) => {
      child.props.onClick?.(event);
      if (!event.defaultPrevented) {
        void openSignIn();
      }
    },
  });
}
